import { useContext } from 'react';
import { PdvOnlineContext } from '../../contexts/PdvOnlineContext';
import { PdvOnlineContextData } from '../../types/context';

export const usePdvOnline = (): PdvOnlineContextData =>
  useContext(PdvOnlineContext);
